import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from 'helpers/number-helper';
import {resolveExposuresOverlap} from 'helpers/exposure';
import Action from 'components/organisms/nhl-team-stacking/actions';

class TeamExposure extends Component {
    constructor(props) {
        super(props);
        const {stacking, team, exposureType, stackNumber} = props;
        this.exposureType = exposureType;
        this.limitValue = 'min' === this.exposureType ? 0 : 100;
        this.isValueBeingChanged = false;
        this.state = {
            value: stacking.getTeamExposureInStackNumber(team, this.exposureType, stackNumber),
        };
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }

    onBlur(value) {
        const exposures = this.normalizeExposures(value);

        this.setState({value: exposures[this.exposureType]});

        this.isValueBeingChanged = false;

        this.props.dispatch(Action.setTeamExposureForStackNumber(this.props.team, exposures, this.props.stackNumber));
    }

    normalizeExposures(value) {
        const {stacking, team, stackNumber} = this.props;
        let exposure = {
            min: stacking.getTeamMinExposureInStackNumber(team, stackNumber),
            max: stacking.getTeamMaxExposureInStackNumber(team, stackNumber),
        };
        exposure[this.exposureType] = NumberHelper.prepareInt(value, this.limitValue)
            .limitByRange(0, 100, 0, 100)
            .get();

        return resolveExposuresOverlap(exposure, this.exposureType);
    }

    getActualValue() {
        let value = this.state.value;
        if (!this.isValueBeingChanged) {
            const {stackNumber, team, stacking} = this.props;
            value = stacking.getTeamExposureInStackNumber(team, this.exposureType, stackNumber);
        }
        return value;
    }

    render() {
        const {className = 'form-control'} = this.props;
        const exposure = this.getActualValue();

        return (
            <input
                onBlur={(e) => ::this.onBlur(e.target.value)}
                onChange={(e) => ::this.onChange(e.target.value)}
                value={`${exposure}`}
                type="number"
                className={className}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(TeamExposure);
